import CircleIcon from '@mui/icons-material/Circle';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';
import { CeleryIcon } from './celery';
import { CrustaceansIcon } from './crustaceans';
import { EggsIcon } from './eggs';
import { FishIcon } from './fish';
import { GlutenIcon } from './gluten';
import { LupinIcon } from './lupin';
import { MilkIcon } from './milk';
import { MolluscsIcon } from './molluscs';
import { MustardIcon } from './mustard';
import { NutsIcon } from './nuts';
import { PeanutsIcon } from './peanuts';
import { SesameIcon } from './sesame';
import { SoyIcon } from './soy';
import { SulphitesIcon } from './sulphites';

const allergenIconMap: Record<string, ComponentType<SvgIconProps>> = {
  gluten: GlutenIcon,
  crustaceans: CrustaceansIcon,
  eggs: EggsIcon,
  fish: FishIcon,
  peanuts: PeanutsIcon,
  soy: SoyIcon,
  milk: MilkIcon,
  nuts: NutsIcon,
  celery: CeleryIcon,
  mustard: MustardIcon,
  sesame: SesameIcon,
  sulphites: SulphitesIcon,
  lupin: LupinIcon,
  molluscs: MolluscsIcon,
};

export function AllergenIcon({ icon, ...props }: SvgIconProps & { icon: string }) {
  const IconComponent = allergenIconMap[icon] ?? CircleIcon;
  return <IconComponent {...props} />;
}
